import { render, staticRenderFns } from "./detailIngameAboard.vue?vue&type=template&id=bc7481d2&scoped=true"
import script from "./detailIngameAboard.vue?vue&type=script&lang=js"
export * from "./detailIngameAboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7481d2",
  null
  
)

export default component.exports